import {styled} from "@nextui-org/react";

/**
 * HTML span element wrapped as a NextUI component.
 */
export const Span = styled("span");

/**
 * HTML div element wrapped as a NextUI component.
 */
export const Div = styled("div");
